import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col, UncontrolledTooltip } from "reactstrap";
import { H6, Image, P } from "../../AbstractElements";
import { getAvatarText, getUserRole } from "../../Services/Shared.service";
import { VendorAgent } from "../../Data/SideMenu/RouteMapping";

const CustomerDetails = ({ tripObj }) => {

  const scannedWhatsappNumber = tripObj.custScannedMobileNumber || "";
  const formattedScannedWhatsappNumber =
    scannedWhatsappNumber.trim().startsWith("91") &&
      scannedWhatsappNumber.trim().length > 10
      ? scannedWhatsappNumber.trim().slice(2)
      : scannedWhatsappNumber.trim();

  const userRole = getUserRole();
  const [profileImage, setProfileImage] = useState("");
  const PickUpDrop = [
    {
      headingClass: "activity-dot-success",
      heading: "Pickup",
      desc: tripObj.pickUpAddress || "-",
    },
    {
      headingClass: "activity-dot-secondary",
      heading: "Drop",
      desc: tripObj.destAddress || "-",
    },
  ];
  useEffect(() => {
    if (Object.keys(tripObj).length == 0) return;
    const letter = getAvatarText(tripObj?.custName);
    setProfileImage(letter);
  }, [tripObj]);
  return (
    <Card className="customer-details">
      <CardBody>
        <Row className="customer-info">
          {/* <Image
            attrImage={{
              className: "img-100 h-100 rounded-circle",
              alt: "",
              src: `${require("../../assets/images/booking/customer.png")}`,
            }}
          /> */}
          <div className="img-100 h-100 rounded-circle profile-image-box">
            <div className="profile-image">{profileImage}</div>
          </div>
          <div className="customer-content">
            <H6>{tripObj.custName || "-"}</H6>
            {
              userRole.some((element) => element !== VendorAgent) ? (
                <>
                  {formattedScannedWhatsappNumber ? (
                    <div>
                      <span
                        id="scannedWhatsappTooltip"
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className="fa fa-phone"
                          style={{ color: "#ffffffff" }}
                        ></i>
                      </span>
                      <span>{`+91 ${formattedScannedWhatsappNumber}`}</span>

                      <UncontrolledTooltip
                        placement="top"
                        target="scannedWhatsappTooltip"
                      >
                        This number was captured during WhatsApp QR scan
                      </UncontrolledTooltip>
                    </div>
                  ) : (
                    <div>
                      <span>
                        <i className="fa fa-phone"></i>
                      </span>
                      <span>
                        {tripObj.custMobile
                          ? `+91 ${tripObj.custMobile}`
                          : "-"}
                      </span>
                    </div>
                  )}
                </>
              ) : (
                ""
              )
            }
          </div>
          <div className="customer-content">
            <div>
              <span>
                <i className="fa fa-envelope"></i>
              </span>
              <span>{tripObj.custEmail || "-"}</span>
            </div>
            <div>
              <span>
                <i className="fa fa-map-marker"></i>
              </span>
              <span>{tripObj.serviceCityName || "-"}</span>
            </div>
          </div>
        </Row>
        <Row className="customer-type">
          <div
            className={`customer-icon ${tripObj.isVip ? "active" : ""}`}
          >
            <i className="fa fa-star"></i>
          </div>
          <div
            className={`customer-icon ${tripObj.isCompanyBooking ? "active" : ""
              }`}
          >
            <i className="fa fa-building-o"></i>
          </div>
        </Row>
        <Row className="pickup-and-drop">
          <Col>
            <Card>
              <CardBody className="new-update">
                <div className="activity-timeline">
                  {PickUpDrop.map((news, i) => (
                    <div className="media" key={i}>
                      {news.line && <div className="activity-line"></div>}
                      <div className={news.headingClass}></div>
                      <div className="media-body">
                        <span>
                          {news.heading} {news.highlight && news.highlight}
                        </span>
                        <P attrPara={{ className: "font-roboto" }}>
                          {news.desc}
                        </P>
                      </div>
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default CustomerDetails;
